import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import moment from "moment"
import { Spinner } from "react-bootstrap"
import styled from 'styled-components';
import ReactLoading from "react-loading";

/* HELPERS */
import { convertToRupiah } from "../../../../utils"

/* IMPORT COMPONENT */
import Breadcrumbs from "./Breadcrumbs";
import Thumbnails from "./Thumbnails";
import LeftContent from "./LeftContent/index";

/* ASSETS */
import SliderLeftHovered from '../../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../../images/right-black-arrow-3.png';
import ArrowBlackRight from '../../../../images/arrow-black-right.png';
import ArrowBlackLeft from '../../../../images/arrow-black-left.png';

const LoadingWrapper = styled.div`
  height: 100%;
  margin-bottom: ${(props) => (props.noWrapper ? "32px" : "0")};
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner-border{
    width: 4em;
    height: 4em;
  }
`

const NextSlide = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      position: absolute;
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        // display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackRight : SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

const PrevSlide = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      position: absolute;
      object-fit: contain;
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        // display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

function DetailSection({ propsForDetailSection = {}, dataProductFromReducer, selectedCategory }) {
  /* PROPS FROM PARENT */
  const {
    currentURL = {},
    selectedSize = {},
    sizeCollapse = "",
    dataCategory = {},
    product: dataProduct = {},
    isHideAllDetails,
    setHideAllDetails,
    onSizeCollapseChanged,
    history,
  } = propsForDetailSection;

  /* LOCAL STATE */
  const [state, setState] = useState({
    currentIndex: 0,
  });

  /* METHODS */
  const changeImage = (currentIndex) => {
    setState({ ...state, currentIndex });
  };

  const parsingHTML = (detailsText) => {
    const content = detailsText === null || detailsText === "" ? `<p></p>` : detailsText;
    const tampilan = {
      __html: `${content}`
    };

    return <div className="description-details" dangerouslySetInnerHTML={tampilan} />
  }

  const [isHideTumbnail, setIsHideTumbnail] = useState(false)

  /* DEFINE VARIABEL */
  const {
    product_variant_images = "",
    display_name = "",
    details = "",
    SKU = "",
    colour = "",
    dimension = "",
    release_date = "",
    retail_price = "",
    editors_choice,
    type
  } = dataProduct;
  // const { selected: category = "" } = dataCategory;
  const category = dataProduct?.product?.category?.name;
  const { user_sell_images = "" } = selectedSize || {};

  /* CONDITION */
  const thumbnailsProps =
    (sizeCollapse === "USED" && selectedSize && user_sell_images.length > 0) ||
      (category === "handbags" && selectedSize && user_sell_images.length > 0)
      ? user_sell_images
      : product_variant_images;

  propsForDetailSection = { ...propsForDetailSection, thumbnailsProps, setIsHideTumbnail }

  const onSwipeSLider = () => {
    if (this.slider) {
      this.slider.innerSlider.clickable = true;
    }
  }

  /* PROPERTIES */
  const previewSettings = {
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    dots: true,
    swipe: true,
    prevArrow: <PrevSlide />,
    nextArrow: <NextSlide />,
    swipeToSlide: true,
    onSwipe: onSwipeSLider,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const isLoading = dataProductFromReducer?.isFetch

  return (
    <div className={`detail-section-outisde-container ${isHideAllDetails ? "hide-details" : ""}`}>
      <div className="detail-section">
        <Breadcrumbs dataProduct={dataProduct} urlProduct={currentURL} />
        <div className={`detail-section-content-wrapper ${isHideTumbnail ? "hide-left-content" : ""}`}>
          <div className="content">
            <div className="left-content">
              <div className="slider-container-outside">
                <div className="slider-container">
                  <Thumbnails
                    settings={previewSettings}
                    afterChange={changeImage}
                    thumbnails={thumbnailsProps}
                    active={state.currentIndex}
                    caption={display_name}
                    category={category}
                    selectedCategory={selectedCategory}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            {isLoading ?
              <LoadingWrapper>
                {/* <Spinner animation="border" size="xl" variant="success" /> */}
                <ReactLoading type={"spin"} height={50} width={50} color={"#159953"} />
              </LoadingWrapper>
              :
              <div className="right-content">
                {<LeftContent propsForLeftContent={propsForDetailSection} />}
              </div>
            }
          </div>
        </div>
      </div>
      {!isHideAllDetails ? isLoading ?
        <LoadingWrapper noWrapper={true}>
          {/* <Spinner animation="border" size="xl" variant="success" /> */}
          <ReactLoading type={"spin"} height={50} width={50} color={"#159953"} />
        </LoadingWrapper>
        :
        <>
          {details &&
            <div className="description-section">
              <p>Description</p>
              {parsingHTML(details)}
            </div>
          }
          {
            window.innerWidth >= 768 ?
              <div className="product-info-section">
                <div>
                  <p>SKU</p>
                  <h2>{SKU || "-"}</h2>
                </div>
                <div>
                  <p>Color</p>
                  <h2>{colour || "-"}</h2>
                </div>
                <div>
                  <p>Material</p>
                  <h2>{type || "-"}</h2>
                </div>
                <div>
                  <p>Dimension</p>
                  <h2>{dimension || "-"}</h2>
                </div>
                <div>
                  <p>Release Date</p>
                  <h2>{release_date ? moment(release_date).format('Do MMMM YYYY') : "-"}</h2>
                </div>
                <div>
                  <p>Retail <i>{`(approx).`}</i></p>
                  <h2>{retail_price ? `$ ${convertToRupiah(parseInt(retail_price))} USD` : "-"}</h2>
                </div>
              </div>
              :
              <div className="scroll-info-wrapper">
                <div className="product-info-section">
                  <div>
                    <p>SKU</p>
                    <h2>{SKU || "-"}</h2>
                  </div>
                  <div>
                    <p>Color</p>
                    <h2>{colour || "-"}</h2>
                  </div>
                  <div>
                    <p>Material</p>
                    <h2>{type || "-"}</h2>
                  </div>
                  <div>
                    <p>Dimension</p>
                    <h2>{dimension || "-"}</h2>
                  </div>
                  <div>
                    <p>Release Date</p>
                    <h2>{release_date ? moment(release_date).format('Do MMMM YYYY') : "-"}</h2>
                  </div>
                  <div>
                    <p>Retail <i>{`(approx).`}</i></p>
                    <h2>{retail_price ? `$ ${convertToRupiah(parseInt(retail_price))} USD` : "-"}</h2>
                  </div>
                </div>
              </div>
          }
          {/* <div className="video-section">
        <div className="video-wrapper">
          <h1>VIDEO SECTION</h1>
        </div>
      </div> */}
        </>
        : null
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    dataProductFromReducer: state?.dataProduct?.productDetails,
    selectedCategory: state?.dataCategory?.selected
  };
};

export default connect(mapStateToProps, null)(DetailSection);
